import script from "./home-content.vue?vue&type=script&lang=ts&setup=true"
export * from "./home-content.vue?vue&type=script&lang=ts&setup=true"

import "./home-content.vue?vue&type=style&index=0&id=6e66b7d8&lang=scss"

const __exports__ = script;

export default __exports__